import { Form, Input } from 'antd';
import { DT } from '@/script/moduleLen.js';

// 创建对象
const DtData = () => {
};

DtData.dtUserCode = () => {
    return (
        <Form.Item name="dtUserCode" label="表代码" rules={[{ required: true }, { max: DT.dtUserCode }]}>
            <Input size="middle" placeholder="表代码" />
        </Form.Item>
    );
};

DtData.dtAlias = () => {
    return (
        <Form.Item name="dtAlias" label="表别名" rules={[{ max: DT.dtAlias }]}>
            <Input size="middle" placeholder="表别名" />
        </Form.Item>
    );
};

DtData.dtName = () => {
    return (
        <Form.Item name="dtName" label="表名称" rules={[{ required: true }, { max: DT.dtName }]}>
            <Input size="middle" placeholder="表名称" />
        </Form.Item>
    );
};

DtData.dtDesc = () => {
    return (
        <Form.Item name="dtDesc" label="说明" rules={[{ max: DT.dtDesc }]}>
            <Input size="middle" placeholder="说明" />
        </Form.Item>
    );
};

DtData.memo = () => {
    return (
        <Form.Item name="memo" label="备注" rules={[{ max: DT.memo }]}>
            <Input.TextArea placeholder="备注" rows={4} />
        </Form.Item>
    );
};

export default DtData;